import React, { useState, Fragment } from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';
import { segmentTrackEvent } from '../../utils';
import { SITE_HOST } from '../../consts';

const CatLinks = ({
  isMobile,
  category
}) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const catLinks = isMobile ? ([
    {id: "fashion", path:"/fashion"},
    {id: "beauty", path: "/beauty"},
    {id: "food", path:"/food"},
    {id: "wellness", path:"/wellness"},
  ]) : ([
    {id: "style", path:"/style"},
    {id: "food", path:"/food"},
    {id: "family", path:"/family"},
    {id: "wellness", path:"/wellness"},
    {id: "about us", path:`${SITE_HOST}/page/about-us`},
  ]);

  const styleDropdown = [
    { id: "fashion", path: "/fashion" },
    { id: "beauty", path: "/beauty" },
    { id: "reviews", path:`${SITE_HOST}/reviews`},
    { id: "shopping", path:`${SITE_HOST}/shopping`},
  ];


  const handleMouseEnter = () => {
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownOpen(false);
  };


  let renderedCatLinks =  catLinks.map(catLink => {
    const catLinkId = catLink.id.replace("-", " ");

    if (catLink.id === "style") {
      return (
        <li key={catLink.id} className="unset-li style-dropdown">
          <a className={`cat-link ${catLink.id} ${category === catLink.id ? 'selected' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} href={catLink.path}>
            {catLinkId}
          </a>
          {!isMobile && (
            <div className={`style-dropdown-list ${isDropdownOpen ? 'open' : 'close'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              {styleDropdown.map((subCat) => (
                <li key={subCat.id} className="dropdown-list-item">
                  {subCat.id === "reviews" || subCat.id === "shopping" ? (
                    <a
                      className="dropdown-link"
                      href={subCat.path}
                      onClick={() => {
                        segmentTrackEvent("navigation", {
                          action: "category_nav_clicked",
                          label: subCat.id,
                        });
                        setIsDropdownOpen(false);
                      }}
                    >
                    {subCat.id}
                   </a>
                  ) : (
                    <Link
                      className="dropdown-link"
                      to={subCat.path}
                      onClick={() => {
                        segmentTrackEvent("navigation", {
                          action: "category_nav_clicked",
                          label: subCat.id,
                        });
                        setIsDropdownOpen(false);
                      }}
                    >
                    {subCat.id.replace("-", " ")}
                   </Link>
                  )}
                </li>
              ))}
            </div>
          )}
        </li>
      );
    }

    if (catLink.id === "about us") {
      return (
      <li className='unset-li'>
        <a 
          key={catLink.id} 
          className={`cat-link ${catLink.id} ${category === catLink.id ? 'selected' : ''}`} 
          href={catLink.path} 
          onClick={() => {segmentTrackEvent('navigation', {action: 'category_nav_clicked', label: catLink.id })}}>
            {catLinkId}
        </a> 
      </li>
      )
    }

    return (
      <li className='unset-li'>
        <Link 
          key={catLink.id} 
          className={`cat-link ${catLink.id} ${category === catLink.id ? 'selected' : ''}`} 
          to={catLink.path} 
          onClick={() => {segmentTrackEvent('navigation', {action: 'category_nav_clicked', label: catLink.id })}}>
            {catLinkId}
        </Link> 
      </li>
    )
  })



  // if (isMobile) {

  // }

  // if (!isMobile) {
  //   renderedCatLinks = [
  //       CatBeauty,
  //       CatWellness,
  //       CatFood,
  //       CatFamily,
  //       CatFashion,
  //       CatPW100
  //   ];
  // }


  return (
    <ul className="cat-links">
      {isMobile
        && <Fragment>
          {renderedCatLinks}
        </Fragment>
      }

      {/* using OutboundLink for styling purposes. Switch to Link to connect to router */}
      {!isMobile
        && <Fragment>
            {renderedCatLinks}
        </Fragment>
      }
    </ul>
  );
};

CatLinks.propTypes = {
  isMobile: PropTypes.bool,
};

export default CatLinks;
